import { render, staticRenderFns } from "./SodEodTeamMemberCard.vue?vue&type=template&id=3afafa95&scoped=true"
import script from "./SodEodTeamMemberCard.vue?vue&type=script&lang=js"
export * from "./SodEodTeamMemberCard.vue?vue&type=script&lang=js"
import style0 from "./SodEodTeamMemberCard.vue?vue&type=style&index=0&id=3afafa95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afafa95",
  null
  
)

export default component.exports